// ./context/course/courseReducer.js

const courseReducer = (state, { type, payload }) => {
    switch (type) {
        // Course Management
        case 'SET_COURSES':
            return {
                ...state,
                courseData: payload,
                isLoading: false,
                error: null
            };

        case 'SET_CURRENT_COURSE':
            return {
                ...state,
                currentCourse: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_COURSE':
            return {
                ...state,
                courseData: [...state.courseData, payload],
                isLoading: false,
                error: null
            };

        case 'UPDATE_COURSE':
            return {
                ...state,
                courseData: state.courseData.map(course =>
                    course.courseId === payload.courseId
                        ? { ...course, ...payload }
                        : course
                ),
                currentCourse: state.currentCourse?.courseId === payload.courseId
                    ? { ...state.currentCourse, ...payload }
                    : state.currentCourse,
                isLoading: false,
                error: null
            };

        case 'DELETE_COURSE':
            return {
                ...state,
                courseData: state.courseData.filter(course => course.courseId !== payload),
                currentCourse: state.currentCourse?.courseId === payload ? null : state.currentCourse,
                isLoading: false,
                error: null
            };

        case 'PUBLISH_COURSE':
            return {
                ...state,
                courseData: state.courseData.map(course =>
                    course.courseId === payload
                        ? { ...course, isPublished: true }
                        : course
                ),
                currentCourse: state.currentCourse?.courseId === payload
                    ? { ...state.currentCourse, isPublished: true }
                    : state.currentCourse,
                isLoading: false,
                error: null
            };

        case 'UNPUBLISH_COURSE':
            return {
                ...state,
                courseData: state.courseData.map(course =>
                    course.courseId === payload
                        ? { ...course, isPublished: false }
                        : course
                ),
                currentCourse: state.currentCourse?.courseId === payload
                    ? { ...state.currentCourse, isPublished: false }
                    : state.currentCourse,
                isLoading: false,
                error: null
            };

        // Lesson Management
        case 'SET_COURSE_LESSONS':
            return {
                ...state,
                courseLessons: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_LESSON':
            return {
                ...state,
                courseLessons: [...(state.courseLessons || []), payload],
                isLoading: false,
                error: null
            };

        case 'UPDATE_LESSON':
            return {
                ...state,
                courseLessons: (state.courseLessons || []).map(lesson =>
                    lesson.lessonId === payload.lessonId
                        ? { ...lesson, ...payload }
                        : lesson
                ),
                isLoading: false,
                error: null
            };

        case 'DELETE_LESSON':
            return {
                ...state,
                courseLessons: (state.courseLessons || []).filter(
                    lesson => lesson.lessonId !== payload
                ),
                isLoading: false,
                error: null
            };

        // Lab Management
        case 'SET_COURSE_LABS':
            return {
                ...state,
                courseLabs: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_LAB':
            return {
                ...state,
                courseLabs: [...state.courseLabs, payload],
                isLoading: false,
                error: null
            };

        case 'UPDATE_LAB':
            return {
                ...state,
                courseLabs: (state.courseLabs || []).filter(Boolean).map(lab =>
                    lab.labId === payload.labId
                        ? { ...lab, ...payload }
                        : lab
                ),
                isLoading: false,
                error: null
            };
                
        case 'DELETE_LAB':
            return {
                ...state,
                courseLabs: state.courseLabs.filter(lab => lab.labId !== payload),
                isLoading: false,
                error: null
            };

        // Quiz Management
        case 'SET_COURSE_QUIZZES':
            return {
                ...state,
                courseQuizzes: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_QUIZ':
            return {
                ...state,
                courseQuizzes: [...state.courseQuizzes, payload],
                isLoading: false,
                error: null
            };

        case 'UPDATE_QUIZ':
            return {
                ...state,
                courseQuizzes: state.courseQuizzes.map(quiz =>
                    quiz.quizId === payload.quizId
                        ? { ...quiz, ...payload }
                        : quiz
                ),
                isLoading: false,
                error: null
            };

        case 'DELETE_QUIZ':
            return {
                ...state,
                courseQuizzes: state.courseQuizzes.filter(quiz => quiz.quizId !== payload),
                isLoading: false,
                error: null
            };

        // Exam Management
        case 'SET_COURSE_EXAMS':
            return {
                ...state,
                courseExams: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_EXAM':
            return {
                ...state,
                courseExams: [...state.courseExams, payload],
                isLoading: false,
                error: null
            };

        case 'UPDATE_EXAM':
            return {
                ...state,
                courseExams: state.courseExams.map(exam =>
                    exam.examId === payload.examId
                        ? { ...exam, ...payload }
                        : exam
                ),
                isLoading: false,
                error: null
            };

        case 'DELETE_EXAM':
            return {
                ...state,
                courseExams: state.courseExams.filter(exam => exam.examId !== payload),
                isLoading: false,
                error: null
            };

        // Capstone Management
        case 'SET_COURSE_CAPSTONES':
            return {
                ...state,
                courseCapstones: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_CAPSTONE':
            return {
                ...state,
                courseCapstones: [...state.courseCapstones, payload],
                isLoading: false,
                error: null
            };

        case 'UPDATE_CAPSTONE':
            return {
                ...state,
                courseCapstones: state.courseCapstones.map(capstone =>
                    capstone.capstoneId === payload.capstoneId
                        ? { ...capstone, ...payload }
                        : capstone
                ),
                isLoading: false,
                error: null
            };

        case 'DELETE_CAPSTONE':
            return {
                ...state,
                courseCapstones: state.courseCapstones.filter(
                    capstone => capstone.capstoneId !== payload
                ),
                isLoading: false,
                error: null
            };

        // Module Management
        case 'SET_COURSE_MODULES':
            return {
                ...state,
                courseModules: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_MODULE':
            return {
                ...state,
                courseModules: [...state.courseModules, payload],
                isLoading: false,
                error: null
            };

        case 'UPDATE_MODULE':
            return {
                ...state,
                courseModules: state.courseModules.map(module =>
                    module.moduleId === payload.moduleId
                        ? { ...module, ...payload }
                        : module
                ),
                isLoading: false,
                error: null
            };

        case 'DELETE_MODULE':
            return {
                ...state,
                courseModules: state.courseModules.filter(
                    module => module.moduleId !== payload
                ),
                isLoading: false,
                error: null
            };

        // Student Enrollment
        case 'SET_ENROLLED_STUDENTS':
            return {
                ...state,
                enrolledStudents: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_ENROLLED_STUDENT':
            return {
                ...state,
                enrolledStudents: [...state.enrolledStudents, payload],
                isLoading: false,
                error: null
            };

        case 'REMOVE_ENROLLED_STUDENT':
            return {
                ...state,
                enrolledStudents: state.enrolledStudents.filter(
                    student => student.studentLoginId !== payload
                ),
                isLoading: false,
                error: null
            };

        // Search and Filter
        case 'SET_SEARCH_RESULTS':
            return {
                ...state,
                searchResults: payload,
                isLoading: false,
                error: null
            };

        case 'SET_PUBLISHED_COURSES':
            return {
                ...state,
                publishedCourses: payload,
                isLoading: false,
                error: null
            };

        // Analytics
        case 'SET_COURSE_ANALYTICS':
            return {
                ...state,
                courseAnalytics: payload,
                isLoading: false,
                error: null
            };

        // Utility Actions
        case 'SET_LOADING':
            return {
                ...state,
                isLoading: payload
            };

        case 'SET_ERROR':
            return {
                ...state,
                error: payload,
                isLoading: false
            };

        case 'CLEAR_COURSE_DATA':
            return {
                courseData: [],
                currentCourse: null,
                courseLessons: [],
                courseLabs: [],
                courseQuizzes: [],
                courseExams: [],
                courseCapstones: [],
                courseModules: [],
                enrolledStudents: [],
                searchResults: [],
                publishedCourses: [],
                courseAnalytics: null,
                isLoading: false,
                error: null
            };

        case 'SET_CATEGORIES':
            return {
                ...state,
                categories: payload,
                isLoading: false,
            };

        case 'ADD_CATEGORY':
            return {
                ...state,
                categories: [...state.categories, payload],
                isLoading: false,
            };

        case 'UPDATE_CATEGORY':
            return {
                ...state,
                categories: state.categories.map(cat =>
                cat.name === payload.oldName ? { ...cat, name: payload.newName } : cat
                ),
                isLoading: false,
            };

        case 'DELETE_CATEGORY':
            return {
                ...state,
                categories: state.categories.filter(cat => cat.name !== payload),
                isLoading: false,
            };

        case 'SET_COURSE_DOMAINS':
            return { 
                ...state, 
                courseDomains: payload 
            };

        default:
            return state;
    }
};

export default courseReducer;